import { emptyString } from "./helpers";
export default class ApiService {
    constructor() {
        //empty
    }
    static async getDataVersion() {
        const url = "api/revwsaa/GetDataVersion";
        let dataVersion = emptyString;
        await fetch(url).then(async (response) => {
            try {
                const data = await response.json();
                dataVersion = data.dataVersion;
            }
            catch (error) {
                console.error("Error getting Data Version: ", error);
            }
        });
        return dataVersion;
    }
    static async getDealerInfo(dataVersion, dealerId) {
        let dealerInfo = null;
        const url = `api/revwsaa/GetDealerList?dataVersion=${dataVersion}&dealerId=${dealerId}`;
        await fetch(url, { method: "POST" }).then(async (response) => {
            try {
                const data = await response.json();
                dealerInfo =
                    data.dealerList.length === 1
                        ? data.dealerList[0]
                        : null;
            }
            catch (error) {
                console.error("Error getting Dealer Info: ", error);
            }
        });
        return dealerInfo;
    }
    static async getDealerDetails(dataVersion, dealerId) {
        let dealerDetails = null;
        const url = `api/revwsaa/GetDealerDetails?dataVersion=${dataVersion}&dealerId=${dealerId}`;
        await fetch(url, { method: "POST" }).then(async (response) => {
            try {
                const data = await response.json();
                dealerDetails = data != null ? data : null;
            }
            catch (error) {
                console.error("Error getting Dealer Info: ", error);
            }
        });
        return dealerDetails;
    }
    static async getCustomerReviews(params) {
        let customerReviews = null;
        const url = `api/revwsaa/GetCustomerReviews`;
        await fetch(url, {
            method: "POST",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
            },
            body: JSON.stringify(params),
        }).then(async (response) => {
            try {
                const data = await response.json();
                if (data != null) {
                    customerReviews = data.reviews;
                }
            }
            catch (error) {
                console.error("Error getting Dealer Info: ", error);
            }
        });
        return customerReviews;
    }
}
